var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-icon',_vm._b({staticClass:"gl-cursor-help",attrs:{"name":"question-o","size":16,"variant":"info"}},'gl-icon',_vm.$attrs,false))
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }